import { render, staticRenderFns } from "./PageBreak.vue?vue&type=template&id=08f6f353&scoped=true&"
var script = {}
import style0 from "./PageBreak.vue?vue&type=style&index=0&id=08f6f353&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f6f353",
  null
  
)

export default component.exports